/// <reference path="Utilities/_reference.ts" />

module YVR.Lounge {
	'use strict';

	// Utilities
	import date = YVR.Utilities.Dates;

	// Classes
	const classes = {
		block: 'yvr-lounge',
		button: 'yvr-lounge__button'
	};


	function main() {
		eventBindings();
	}


	/**
	 * Set the event bindings on the lounge elements.
	 */
	function eventBindings() {
		$(`.${classes.block}`).on('click', `.${classes.button}`, e => {
			e.preventDefault();

			const form = $(e.target).parents('form');
			const valid = form.parsley().validate();

			if (valid) {
				submitForm(form);
			}
		});
	}


	/**
	 * Submits the form and sends the user to the correct lounge service.
	 * @param {obj} form A jQuery object that contains the lounge form.
	 */
	function submitForm(form) {

		const startDate = form.find('.yvr-form__date--start').val();
		const startTime = form.find('.yvr-form__time--start').val();

		const startDatetime = date.getDatetimeFromStrings(startDate, startTime);

		// Get entry Day
		const ddd = startDatetime.getDate();

		if (ddd > 0 && ddd < 10) {
			form.find('#fdd').val(`0${ddd}`);
		} else {
			form.find('#fdd').val(`${ddd}`);
		}

		// Get entry MMYYYY
		const dmonth = startDatetime.getMonth() + 1;
		const dYear = startDatetime.getFullYear();

		// Adding 0 in front of month value if single digit
		if (dmonth > 0 && dmonth < 10) {
			form.find('#fdmy').val(`0${dmonth}${dYear}`);
		} else if (dmonth < 13) {
			form.find('#fdmy').val(`${dmonth}${dYear}`);
		}

		// Get entry hour
		const dHour = startDatetime.getHours();
		let fdt = '';

		if (dHour >= 0 && dHour < 10) {
			fdt = (`0${(dHour).toString()}`);
		} else {
			fdt = (`${(dHour).toString()}`);
		}

		// Get entry minute
		const dMin = startDatetime.getMinutes();

		if (dMin >= 0 && dMin < 10) {
			fdt += (`:0${(dMin).toString()}`);
		} else {
			fdt += (`:${(dMin).toString()}`);
		}
		form.find('#fdt').val(fdt);


		if (!form.find('#yvr-lounge-persons-children').val()) {
			form.find('#yvr-lounge-persons-children').val('00');
		}

		window.open('', 'chauntryWindow');
		form.submit();
	}

	main();
}
